import { setSubroute } from 'store/navbar'
import { injectReducers } from 'store/reducers'
import { syncStudyModuleViewport } from 'router/viewportWidth'
import { setPageTitle } from 'utils/misc'
import VisitScheduleNav from './routes/VisitScheduleNav'
import VisitSchedulesPageRoute from './routes/VisitSchedulesPage'
import VisitSchedules from './routes/VisitSchedulesPage/modules/VisitSchedules'

export default store => {
  injectReducers(store, { visitSchedules: VisitSchedules })
  const visitSchedulesPageRoute = VisitSchedulesPageRoute(store)

  return {
    path: 'visit-schedules',
    exact: true,
    indexRoute: {
      ...visitSchedulesPageRoute,
      getComponent(nextState, cb) {
        store.dispatch(setSubroute('visitSchedules'))
        const { currentStudy } = store.getState().study
        setPageTitle(`Visits Schedule | Study ${currentStudy?.id ?? ''} | ${currentStudy?.platform_name ?? ''}`)
        visitSchedulesPageRoute.getComponent(nextState, cb)
      },
    },
    getChildRoutes(location, cb) {
      syncStudyModuleViewport(store, location, 'visit-schedules')
      cb(null, [VisitScheduleNav(store)])
    },
  }
}
